module.exports = __webpack_public_path__ + "img/our-marketing-bg.4d892cc9.jpg";